//Author: Grant Pierce
//Email: grant@simplestepsweb.com
//Organization: Simple Steps Web Development
//Website: https://www.simplestepsweb.com
$(function(){
    //track add to wishlist from product detail page
    $('body').on('click', '.swym-add-to-wishlist', function(){
      if(fbq){
  		fbq('track', 'AddToWishlist');
      }
    });
    //track add to wishlist from listing page
    $('body').on('click', '.swym-add-to-wishlist-view-product', function(){
      if(fbq){
  		fbq('track', 'AddToWishlist');
      }
    });
});